<template>
	<div class="DqsContainer" :class="{ 'is-visible': isVisible }">
		<svg
			class="ScoreContainer"
			viewBox="0 0 36 36"
		>
			<path
				:stroke="strokeColor"
				:stroke-dasharray="strokeDashArray"
				class="DqsBorder"
				d="M18 2.0845
				a 15.9155 15.9155 0 0 1 0 31.831
				a 15.9155 15.9155 0 0 1 0 -31.831"
				fill="none"
				stroke-width="1"
			/>
			<text
				x="18"
				y="23"
				class="TheScore"
			>{{ calculatedDqs }}
			</text>
		</svg>
	</div>
</template>

<script>
export default {
	name: "Dqs",
	props: {
		calculatedDqs: {
			type: String,
			default: "0"
		},
		strokeColor: {
			type: String,
			default: "transparant"
		},
		strokeDashArray: {
			type: String,
			default: "0 100"
		},
		isVisible: {
			type: Boolean,
			default: false,
		}
	},
	data: function() {
		return {
			dqs: this.calculatedDqs
		};
	}
};
</script>

<style lang="scss">
@import '../styles/main';

.DqsContainer {
	width: 100%;
	height: 100%;
	visibility: hidden;

	&.is-visible {
		visibility: visible;

		.ScoreContainer {
			display: flex;
			align-items: baseline;
		}

		.DqsBorder {
			fill: none;
			stroke-width: 2.8;
			stroke-linecap: round;
			animation: progress 2.5s ease-out;
		}

		.TheScore {
			font-size: 1rem;
			text-anchor: middle;
			animation: show 3s ease-out;
		}
	}

	@keyframes progress {
		0% {
			stroke-dasharray: 0 100;
		}
	}

	@keyframes show {
		0% {
			fill: transparent;
		}
		33% {
			fill: transparent;
		}
		100% {
			fill: $GreyDD;
		}
	}
}
</style>
